module.exports = __webpack_public_path__ + "img/index-2.62b05eb7.png";